import { useRouter } from 'next/router';
import { ReactNode } from 'react';

const GuardLoaderComponent = ({ children }: { children: ReactNode }) => {
  const router = useRouter();

  if (router.pathname === '/employer/job-positions/onboarding') return null;

  return <>{children}</>;
};

export default GuardLoaderComponent;
